import { FormInputLabel, Input, Group } from './form-input.styles';

const FormInput = ({ label, ...inputProps }) => {
  return (
    <Group>
      <Input {...inputProps} />
      {label && (
        <FormInputLabel shrink={inputProps.value.length} htmlFor={label}>
          {label}
        </FormInputLabel>
      )}
    </Group>
  );
};

export default FormInput;
